import { render, staticRenderFns } from "./PollPreview.vue?vue&type=template&id=2b766949"
import script from "./PollPreview.vue?vue&type=script&lang=js"
export * from "./PollPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports